import { type AssetDragItem, type BoardDragItem, isBoardDragType } from '~/components/Shared/Drag/dragTypes';

export const isBoardDragItem = (item: AssetDragItem | BoardDragItem): item is BoardDragItem =>
  isBoardDragType(item.type);
